export default __webpack_public_path__ + "static/media/contact.c3f83e0f.jpg";